/**
 * 응답 제어 모듈 프롬프트 버전 태그 → Badge variant 매핑.
 * 흔히 쓰는 운영 라벨 (production/stable/draft) 을 색으로 즉시 식별.
 */
type TagVariant = 'default' | 'accent' | 'outline' | 'muted';

const ACCENT_TAGS = new Set(['production', 'prod', 'stable', 'live', '운영', '안정']);
const OUTLINE_TAGS = new Set(['draft', 'wip', 'beta', 'experimental', '초안', '실험']);

export function variantForTag(tag: string): TagVariant {
  const k = tag.toLowerCase();
  if (ACCENT_TAGS.has(k)) return 'accent';
  if (OUTLINE_TAGS.has(k)) return 'outline';
  return 'default';
}
